import { useContext, useMemo } from 'react';
import { UserMetadataContext } from '../components/UserMetadataProvider';

export const useUserHasTableauAccess = () => {
  const { state } = useContext(UserMetadataContext);
  const hasAccess = useMemo(() => !!state.tableauMetadata?.hasTableauLicense, [state]);
  return hasAccess;
};
